import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Input, Checkbox, Button } from 'antd-v5';
import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const StoresFilterModal = ({ open, onClose, stores, includedStoreIds, onApply }) => {
  const [localIds, setLocalIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (open) {
      setLocalIds(includedStoreIds || []);
      setSearchTerm('');
    }
  }, [open, includedStoreIds]);

  const filteredStores = useMemo(() => {
    if (!searchTerm.trim()) return stores;
    const lower = searchTerm.toLowerCase();
    return stores.filter(s => s.name?.toLowerCase().includes(lower));
  }, [stores, searchTerm]);

  const handleCheckboxChange = (storeId, checked) => {
    if (checked) {
      setLocalIds(prev => [...prev, storeId]);
    } else {
      setLocalIds(prev => prev.filter(id => id !== storeId));
    }
  };

  const handleApply = () => {
    onApply(localIds);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Stores"
      className="audience-filter-modal"
      width={480}
      centered
      footer={
        <div className="audience-filter-modal__footer">
          <Button
            type="link"
            onClick={() => setLocalIds([])}
            disabled={localIds.length === 0}
          >
            Clear
          </Button>
          <div className="audience-filter-modal__footer-right">
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={handleApply}>
              Apply
            </Button>
          </div>
        </div>
      }
    >
      <p style={{ color: '#666', fontSize: 14, marginBottom: 16 }}>
        Select stores to include in your audience.
      </p>

      <Input
        placeholder="Search stores"
        prefix={<SearchOutlined />}
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        style={{ marginBottom: 16 }}
      />

      <div className="audience-filter-checklist">
        {filteredStores.length === 0 ? (
          <div className="audience-filter-checklist__empty">No stores found</div>
        ) : (
          filteredStores.map(store => (
            <div key={store.id} className="audience-filter-checklist__item">
              <Checkbox
                checked={localIds.includes(store.id)}
                onChange={e => handleCheckboxChange(store.id, e.target.checked)}
              >
                {store.name}
              </Checkbox>
            </div>
          ))
        )}
      </div>
    </Modal>
  );
};

StoresFilterModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  stores: PropTypes.array,
  includedStoreIds: PropTypes.array,
  onApply: PropTypes.func.isRequired,
};

StoresFilterModal.defaultProps = {
  stores: [],
  includedStoreIds: [],
};

export default StoresFilterModal;
